<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver-es';
import {exportDataGrid} from 'devextreme/excel_exporter';
import Loader from "../components/loader.vue";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxGroupPanel, DxGrouping, DxFilterRow,
  DxPager, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader,
    DxDataGrid, DxColumn,
    DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxGroupPanel, DxGrouping, DxFilterRow,
    DxPager, DxRemoteOperations,
    Loader
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return {dropzoneFile, drop};
  },

  data() {

    return {
      title: "Histórico de Cotações (CT-e)",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Histórico de Cotações (CT-e)",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,

      errosValid: null,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,
      updating: false,

    };
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted comp_0')
    this.atualizaDataList()
  },

  methods: {


    confirmarPeriodo() {
      console.log('confirmarPeriodo')
      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))
      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    carregouGrid(e) {
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      this.title = `(${e.component.totalCount()}) Histórico de Cotações (CT-e): ${dtIniFormated} - ${dtFimFormated}`
    },


    atualizaDataList() {
      console.log('atualizaDataList_mov')
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      this.updating = false

      let hoje = moment()
      hoje.add(-30, 'days')

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "id",
        load: function (loadOptions) {
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }

          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/mctescotaconcs`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_0')
            console.log(response.data[0])

            response.data[0].forEach((pedido) => {
              if (pedido.inicio) {
                pedido.inicio = moment(pedido.inicio).format('DD/MM/YYYY HH:mm')
              }
              if (pedido.entrega) {
                pedido.entrega = moment(pedido.entrega).format('DD/MM/YYYY HH:mm')
              }
            })

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'TRA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }


      }
    },


    onExporting(e) {
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], {type: 'application/octet-stream'}), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },


    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true"/>


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxGroupPanel :visible="true"/>
        <DxGrouping/>
        <DxColumn
            data-field="id"
            caption="ID"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            caption="CT-e"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="ctcodigo"
              caption="Nº CT-e"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="ctemis"
              caption="Data CT-e"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy hh:mm"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              caption="Transportadora"
              alignment="center"
              :allow-sorting="false"
              :allowHeaderFiltering="false">

            <DxColumn
                data-field="ctranspcnpj"
                caption="CNPJ"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctranspnome"
                caption="Nome"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

          </DxColumn>

          <DxColumn
              caption="Destinatário"
              alignment="center"
              :allow-sorting="false"
              :allowHeaderFiltering="false">

            <DxColumn
                data-field="ctdestcnpj"
                caption="CNPJ"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctdestnome"
                caption="Nome"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctdestmun"
                caption="Cidade"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctdestuf"
                caption="Estado"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctdestcep"
                caption="CEP"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="prazo"
                caption="Prazo"
                data-type="number"
                :format="formatDecimal"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctvalor"
                caption="Valor"
                data-type="number"
                :format="formatDecimal"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctcub"
                caption="Cubagem"
                data-type="number"
                :format="formatDecimal"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="ctpeso"
                caption="Peso"
                data-type="number"
                :format="formatDecimal"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="nfvalor"
                caption="Valor Notas"
                data-type="number"
                :format="formatDecimal"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true"/>


          </DxColumn>

        </DxColumn>

        <DxColumn
            caption="Cotação"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              caption="Transportadora"
              alignment="center"
              :allow-sorting="false"
              :allowHeaderFiltering="false">

            <DxColumn
                data-field="cotranspcnpj"
                caption="CNPJ"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

            <DxColumn
                data-field="cotranspnome"
                caption="Nome"
                alignment="left"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

          </DxColumn>


          <DxColumn
              data-field="coprazo"
              caption="Prazo"
              data-type="number"
              :format="formatDecimal"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>


          <DxColumn
              data-field="covalor"
              caption="Valor"
              data-type="number"
              :format="formatDecimal"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

        </DxColumn>

        <DxColumn
            data-field="difctco"
            caption="Dif.Cte/Cotação"
            data-type="number"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="minvalor"
            caption="Menor Valor"
            data-type="number"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="difctcoperc"
            caption="Dif.Cte/Cotação(%)"
            data-type="number"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cuscomp"
            caption="Custo Comp."
            data-type="number"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="fretekg"
            caption="Frete KG"
            data-type="number"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="econoperc"
            caption="Economia (%)"
            data-type="number"
            :format="formatDecimal"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>
      </DxDataGrid>
    </div>


  </Layout>


  <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
    <div class="col-md-12">
      <div class="mb-3">
        <label for="tipooperacao">Selecionar Data Inicial e Final</label>

      </div>
    </div>
    <div class="row">

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtIniFiltro">Data Início</label>
          <input
              id="dtIniFiltro"
              v-model="dtIniFiltro"
              type="date"
              class="form-control"
              placeholder="Data Início"
              :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
          <div v-if="submittedPeriodo && !dtIniFiltro"
               class="invalid-feedback">
            <span>Campo data início obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtFimFiltro">Data Final</label>
          <input
              id="dtFimFiltro"
              v-model="dtFimFiltro"
              type="date"
              class="form-control"
              placeholder="Data Final"
              :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
          <div v-if="submittedPeriodo && !dtFimFiltro"
               class="invalid-feedback">
            <span>Campo data final obrigatória, favor preencher.</span>
          </div>
        </div>
      </div>

    </div>
    <div class="text-end mt-5">
      <b-button variant="light" @click="showModalPeriodo = false">
        <i class="bx bx-block font-size-16 align-middle me-2"></i>
        Cancelar
      </b-button>
      <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
        <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
        Confirmar
      </b-button>
    </div>
  </b-modal>


</template>
